import { useEffect, useRef } from "react";
import { toggleDropdown } from "../../Managment/Slice";
import { useDispatch } from "react-redux";
import { useStateContext } from "../../Providers/ContextProvider";

function DropDown({ links, isOpen, dropdownId, onSelect }) {
  const { setSelectedItems } = useStateContext();
  const dispatch = useDispatch();
  const dropdownRef = useRef(null);

  const handleClick = (text) => {
    setSelectedItems((prevItems) => {
      const newItems = [...prevItems];
      newItems[dropdownId] = text;
      return newItems;
    });
    onSelect(text);
    dispatch(toggleDropdown({ index: dropdownId })); // Note: match your Navbar dispatch key
  };

  // Close when clicking outside
  useEffect(() => {
    function handleClickOutside(event) {
      if (
        isOpen &&
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target)
      ) {
        dispatch(toggleDropdown({ index: dropdownId }));
      }
    }
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, [isOpen, dropdownId, dispatch]);

  if (!isOpen) return null;

  return (
    <div
      ref={dropdownRef}
      className="absolute top-full right-0 mt-2 z-50 bg-white divide-y divide-gray-100 rounded-lg shadow-xl w-44 border border-gray-100 overflow-hidden"
    >
      <ul className="py-2 text-sm text-gray-700 text-right">
        {links.map((link, index) => (
          <li key={index}>
            <button
              type="button"
              onClick={() => handleClick(link.text)}
              className="w-full text-right block px-4 py-2 hover:bg-gray-100 transition-colors"
            >
              {link.text}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}

export default DropDown;
